<div
  class="status ltr"
  [class.status--updating]="isUpdating"
  [class.status--dialog-open]="isDialogOpen"
>
  <nb-toggle
    labelPosition="right"
    [checked]="isAvailable"
    [disabled]="isBusy"
    (checkedChange)="onStatusChange($event)"
    [attr.aria-label]="
      isAvailable ? 'تغییر وضعیت از در دسترس' : 'تغییر وضعیت به در دسترس'
    "
    >{{ isAvailable ? 'در دسترس' : 'عدم دسترسی' }}</nb-toggle
  >
  <span class="status-loader" *ngIf="isUpdating" aria-hidden="true"></span>
</div>

<ng-template #availabilityDialog let-dialogRef="dialogRef">
  <nb-card class="availability-dialog" dir="rtl">
    <nb-card-header class="dialog-header">
      <div class="dialog-title-wrap">
        <span class="dialog-icon" aria-hidden="true">
          <nb-icon icon="clock-outline"></nb-icon>
        </span>
        <div>
          <h2>ساعت کاری امروز</h2>
          <p>
            وضعیت شما به
            <strong>{{
              pendingAvailabilityValue ? 'در دسترس' : 'عدم دسترسی'
            }}</strong>
            تغییر می‌کند.
          </p>
        </div>
      </div>
    </nb-card-header>

    <nb-card-body>
      <form
        [formGroup]="messageForm"
        (ngSubmit)="submitAvailabilityMessage(dialogRef)"
      >
        <section class="time-section" aria-labelledby="time-range-title">
          <div class="section-heading">
            <div>
              <h3 id="time-range-title">انتخاب بازه ساعت</h3>
              <p>بازه اصلی را انتخاب کنید؛ نیم‌ساعت‌ها هم در دسترس‌اند.</p>
            </div>
          </div>

          <div class="time-range-grid">
            <label class="time-field">
              <span class="time-label">
                <span class="time-dot time-dot--start"></span>
                شروع کار
              </span>
              <nb-select
                fullWidth
                formControlName="start"
                placeholder="ساعت شروع"
                aria-label="ساعت شروع کار"
              >
                <nb-option *ngFor="let time of timeOptions" [value]="time">
                  <bdi dir="ltr">{{ time }}</bdi>
                </nb-option>
              </nb-select>
            </label>

            <span class="range-connector" aria-hidden="true">
              <span></span>
              تا
              <span></span>
            </span>

            <label class="time-field">
              <span class="time-label">
                <span class="time-dot time-dot--end"></span>
                پایان کار
              </span>
              <nb-select
                fullWidth
                formControlName="end"
                placeholder="ساعت پایان"
                aria-label="ساعت پایان کار"
              >
                <nb-option *ngFor="let time of timeOptions" [value]="time">
                  <bdi dir="ltr">{{ time }}</bdi>
                </nb-option>
              </nb-select>
            </label>
          </div>

          <p class="range-error" *ngIf="hasInvalidTimeRange">
            <nb-icon icon="alert-circle-outline"></nb-icon>
            ساعت پایان باید بعد از ساعت شروع باشد.
          </p>

          <div class="preset-list" aria-label="بازه‌های پیشنهادی">
            <span>انتخاب سریع:</span>
            <button
              *ngFor="let preset of rangePresets"
              type="button"
              class="preset-chip"
              [class.preset-chip--active]="
                messageForm.get('start')?.value === preset.start &&
                messageForm.get('end')?.value === preset.end
              "
              (click)="usePreset(preset.start, preset.end)"
            >
              {{ preset.label }}
            </button>
          </div>
        </section>

        <section class="message-section" aria-labelledby="message-title">
          <div class="section-heading section-heading--message">
            <div>
              <h3 id="message-title">متن قابل نمایش</h3>
              <p>
                بخش قبل و بعد ثابت می‌ماند، اما هر زمان خواستید قابل ویرایش است.
              </p>
            </div>
            <span class="optional-badge">اختیاری</span>
          </div>

          <div class="copy-fields">
            <label>
              <span>متن قبل از ساعت</span>
              <input
                nbInput
                fullWidth
                formControlName="prefix"
                maxlength="160"
                autocomplete="off"
              />
            </label>
            <label>
              <span>متن بعد از ساعت</span>
              <input
                nbInput
                fullWidth
                formControlName="suffix"
                maxlength="160"
                autocomplete="off"
              />
            </label>
          </div>

          <div class="message-preview" aria-live="polite">
            <div class="preview-icon" aria-hidden="true">
              <nb-icon icon="message-square-outline"></nb-icon>
            </div>
            <div>
              <span>پیش‌نمایش متن درباره من</span>
              <p>{{ messagePreview }}</p>
            </div>
          </div>
        </section>
      </form>
    </nb-card-body>

    <nb-card-footer class="dialog-footer">
      <div class="primary-actions">
        <button
          nbButton
          status="basic"
          appearance="outline"
          type="button"
          (click)="changeStatusWithoutMessage(dialogRef)"
        >
          تغییر وضعیت بدون پیام
        </button>
        <button
          nbButton
          status="primary"
          type="button"
          [disabled]="messageForm.invalid || hasInvalidTimeRange"
          (click)="submitAvailabilityMessage(dialogRef)"
        >
          ذخیره و تغییر وضعیت
          <nb-icon icon="checkmark-outline"></nb-icon>
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
